import { call, put, takeLatest } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {FETCH_DRAWER_MENU,  SET_DRAWER_MENU} from "../actions";

export function* FetchDrawerMenuSaga() {
    try {

        const response = yield call(GET, ApiRouts.API_DRAWER_MENU , {});

        if (response) {

            yield put({
                type:SET_DRAWER_MENU,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* drawerMenuSaga() {
    yield takeLatest(FETCH_DRAWER_MENU, FetchDrawerMenuSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default drawerMenuSaga;
